import { transport } from '@opengov/app-core/transport';
import { useQuery } from '@tanstack/react-query';
import { customReportsQueryKeys } from './customReportsQueryKeys';

type NamedRangeMarkupResponse = {
  html: string;
  metadata: {
    mode: 'single' | 'split';
    printTablesCount: number;
    namedRangeId: string;
    namedRangeName: string;
  };
};

type Params = {
  publicationId: string;
  spreadsheetId: string;
  namedRangeId: string;
};

async function fetchNamedRangeMarkup({
  publicationId,
  spreadsheetId,
  namedRangeId
}: Params): Promise<NamedRangeMarkupResponse> {
  return transport
    .url(
      `/api/stories/v1/publications/${publicationId}/spreadsheets/${spreadsheetId}/named-ranges/${namedRangeId}/markup`
    )
    .get()
    .json();
}

export function useFetchNamedRangeMarkup({
  publicationId,
  spreadsheetId,
  namedRangeId,
  enabled
}: Params & { enabled: boolean }) {
  return useQuery({
    queryKey: customReportsQueryKeys.namedRangeMarkup({ publicationId, spreadsheetId, namedRangeId }),
    queryFn: () => fetchNamedRangeMarkup({ publicationId, spreadsheetId, namedRangeId }),
    enabled
  });
}
